/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TipiEntiResDto } from '../../models/tipi-enti-res-dto';

export interface TipiEntiControllerFindManyTipiEnti$Params {}

export function tipiEntiControllerFindManyTipiEnti(
  http: HttpClient,
  rootUrl: string,
  params?: TipiEntiControllerFindManyTipiEnti$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<TipiEntiResDto>>> {
  const rb = new RequestBuilder(
    rootUrl,
    tipiEntiControllerFindManyTipiEnti.PATH,
    'get',
  );
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TipiEntiResDto>>;
      }),
    );
}

tipiEntiControllerFindManyTipiEnti.PATH = '/tipiEnti';
